import {
  Sheet,
  Typography,
  Container,
  Box,
  MenuButton,
  Dropdown,
  MenuItem,
  Menu,
} from "@mui/joy";

import * as React from "react";
import Modal from "@mui/joy/Modal";
import ModalClose from "@mui/joy/ModalClose";
import FooterComponent from "../components/FooterComponent";

function LandingPage() {
  const [open, setOpen] = React.useState(false);

  // Define the gradient style for the text
  const gradientTextStyle = {
    background:
      "linear-gradient(90deg, rgba(69, 39, 160, 1) 0%, rgba(176, 70, 255, 1) 100%)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    display: "inline", // Required for gradient to apply only to text
  };

  // Style to adjust vertical alignment of the image
  const imageStyle = {
    width: "3em",
    height: "2.5em",
    verticalAlign: "middle", // Centers the image vertically, adjust this value as needed
    position: "relative", // Allows fine control of the image's position
    top: "0.5em", // Pushes the image slightly down; adjust as needed
    marginRight: "-0.20em",
  };

  return (
    <>
      <Sheet
        sx={{
          minHeight: "100vh",
          bgcolor: "transparent",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "flex", // Aligns content to the right
        }}
      >
        <Container
          sx={{
            flex: "1 1 auto",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Box sx={{ textAlign: "center", mb: 4 }}>
            <Typography level="h1">
              Welcome to
              <Box
                component="span"
                sx={{ display: "inline-flex", alignItems: "center" }}
              >
                <img src="/logo.png" alt="Tune" style={imageStyle} />
              </Box>
            </Typography>
          </Box>

          <Box sx={{ textAlign: "center" }}>
            {" "}
            {/* Right aligns the text */}
            <Typography level="body1" sx={{ mb: 4, width:400 }}>
              An all-encompassing music streaming platform, with dating-app-esque swiping to discover new music and explore new genres.
            </Typography>
            <Dropdown>
              <MenuButton
                variant="solid"
                size="lg"
                sx={{
                  backgroundColor: "#6D597A",
                  ":hover": { backgroundColor: "#55415f" },
                  m: 2,
                }}
              >
                Download Tune
              </MenuButton>
              <Menu>
                <MenuItem
                  onClick={() =>
                    window.open(
                      "https://apps.apple.com/us/app/velbit/id1569973183"
                    )
                  }
                >
                  <i className="fa-brands fa-apple"></i> iOS
                </MenuItem>
                <MenuItem
                  onClick={() =>
                    window.open(
                      "https://play.google.com/store/apps/details?id=media.obit&hl=en_US&gl=US"
                    )
                  }
                >
                  <i className="fa-brands fa-android"></i> Android
                </MenuItem>
              </Menu>
            </Dropdown>
            <Dropdown>
              <MenuButton
                variant="solid"
                size="lg"
                sx={{
                  backgroundColor: "#d78d82",
                  ":hover": { backgroundColor: "#ba6c61" },
                  m: 2,
                }}
              >
                Join The Team
              </MenuButton>
              <Menu>
                <MenuItem onClick={() => setOpen(true)}>
                  Volunteer
                </MenuItem>
              </Menu>
            </Dropdown>
          </Box>
        </Container>

        <Modal
          aria-labelledby="modal-title"
          aria-describedby="modal-desc"
          open={open}
          onClose={() => setOpen(false)}
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Sheet
            variant="outlined"
            sx={{
              maxWidth: 500,
              borderRadius: "md",
              p: 3,
              boxShadow: "lg",
            }}
          >
            <ModalClose variant="plain" sx={{ m: 1 }} />
            <Typography
              component="h2"
              id="modal-title"
              level="h4"
              textColor="inherit"
              fontWeight="lg"
              mb={1}
            >
              Tune Volunteer
            </Typography>
            <Typography id="modal-desc" textColor="text.tertiary">
              The Tune volunteer program is currently closed. Please check back later.
            </Typography>
          </Sheet>
        </Modal>

        <FooterComponent />
      </Sheet>
    </>
  );
}

export default LandingPage;
